import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';

@Component({
  standalone: true,
  imports: [CommonModule, TranslocoPipe],
  providers: [TranslocoService],
  selector: 'nggt-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span
      class="created-by"
      [innerHTML]="'siteCreator' | transloco: { name: creatorName(), year: creationYear(), link: creatorLink() }"
    >
      <!-- Created with ♥ by
      <b
        ><a [href]="creatorLink()" target="_blank">{{ creatorName() }}</a></b
      >
      {{ creationYear() | date : 'yyyy' }} -->
    </span>
    <div class="socials">
      <a href="#" target="_blank" class="ion ion-social-github"></a>
      <a href="#" target="_blank" class="ion ion-social-facebook"></a>
      <a href="#" target="_blank" class="ion ion-social-twitter"></a>
      <a href="#" target="_blank" class="ion ion-social-linkedin"></a>
    </div>
  `,
})
export class FooterComponent {
  creatorLink = input<string>('https://kingpeti.com/');
  creatorName = input<string>('kingpeti');
  creationYear = input<number>(new Date().getFullYear());
}
